export enum HraProviderType {
    None = 'None',
    WellSource = 'WellSource',
    InfoTech = 'InfoTech',
    HPInfoTech = 'HPInfoTech',
    VirginPulse = 'VirginPulse'
}
